import { render, staticRenderFns } from "./Totals.vue?vue&type=template&id=4ef20336&scoped=true&"
import script from "./Totals.vue?vue&type=script&lang=ts&"
export * from "./Totals.vue?vue&type=script&lang=ts&"
import style0 from "./Totals.vue?vue&type=style&index=0&id=4ef20336&scoped=true&lang=css&"
import style1 from "./Totals.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef20336",
  null
  
)

export default component.exports